module.exports = __webpack_public_path__ + "img/word.735f0e8c.png";